import ComponentLayout from "../../../../src/layouts/component-layout";
import anatomy from "../../../../content/components/BreakoutBanner/images/anatomy.png";
import doPosition from "../../../../content/components/BreakoutBanner/images/do-position.png";
import dontPosition from "../../../../content/components/BreakoutBanner/images/dont-position.png";
import doAlign from "../../../../content/components/BreakoutBanner/images/do-align.png";
import dontAlign from "../../../../content/components/BreakoutBanner/images/dont-align.png";
import doUseSparingly from "../../../../content/components/BreakoutBanner/images/do-use-sparingly.png";
import dontStack from "../../../../content/components/BreakoutBanner/images/dont-stack.png";
import doLength from "../../../../content/components/BreakoutBanner/images/do-length.png";
import dontLength from "../../../../content/components/BreakoutBanner/images/dont-length.png";
import doBG from "../../../../content/components/BreakoutBanner/images/do-bg.png";
import dontBG from "../../../../content/components/BreakoutBanner/images/dont-bg.png";
import doLeadingVisual from "../../../../content/components/BreakoutBanner/images/do-leading-visual.png";
import dontLeadingVisual from "../../../../content/components/BreakoutBanner/images/dont-leading-visual.png";
import doLeadingVisualColor from "../../../../content/components/BreakoutBanner/images/do-leading-visual-color.png";
import dontLeadingVisualColor from "../../../../content/components/BreakoutBanner/images/dont-leading-visual-color.png";
import * as React from 'react';
export default {
  ComponentLayout,
  anatomy,
  doPosition,
  dontPosition,
  doAlign,
  dontAlign,
  doUseSparingly,
  dontStack,
  doLength,
  dontLength,
  doBG,
  dontBG,
  doLeadingVisual,
  dontLeadingVisual,
  doLeadingVisualColor,
  dontLeadingVisualColor,
  React
};